<template>
  <v-flex
    v-if="
      exibeTesteGratis &&
      !getAcessoModulo({ user: user, modulo: SALVAR_DIETA }) &&
      !user.testou_premium &&
      ((user.plano !== null && user.plano.id_empresa === null) ||
        user.plano === null)
    "
    style="opacity: 0.7"
    xs12
    @click="testePremium"
  >
    <v-btn
      rounded
      color="#008000"
      dark
      style="
        margin-bottom: 15px;
        border-radius: 10px;
        width: 600px;
        height: 65px;
      "
    >
      <span style="font-weight: 600; padding: 4px; font-size: 18px">
        {{ strings[idioma].experimente_gratis_7_dias }}
      </span>
    </v-btn>
  </v-flex>
</template>
<script>
import { mapState } from "vuex";
import { SALVAR_DIETA } from "../../utils/types";

export default {
  data() {
    return {
      SALVAR_DIETA: SALVAR_DIETA,
    };
  },
  computed: {
    ...mapState("app", [
      "dietasAtivas",
      "data",
      "acesso_premium",
      "strings",
      "idioma",
      "user",
      "ingredientes",
      "optionsNumber",
      "alimentos_selecionados",
      "categorias_alimentos",
      "alimentos_usuario",
      "alert",
      "dietas",
      "predicoes",
      "tabelas",
      "empresa",
      "tabHome",
      "exibeTesteGratis",
    ]),
  },
  methods: {
    testePremium() {
      let isPendente = localStorage.getItem("pendente");
      if (isPendente) {
        this.alertAtualizeOsDados();
        return;
      }

      if (
        !confirm(this.strings[this.idioma].voce_realmente_quer_ativar_premium)
      ) {
        return;
      }
      this.axios.post("user/testarPremium").then((r) => {
        setTimeout(() => {
          window.location.href = "/";
        }, 1000);
        this.sweetAlert(
          this.strings[this.idioma].experimente_gratis_7_dias_confirmar
        );
      });
    },
  },
};
</script>
